
/* === vd-card-enhancers.js === */

  (function(){
    if (window.__vd_qs_loaded) return;
    window.__vd_qs_loaded = true;
    function handleToggle(e) {
      var toggle = e.target.closest('.product-item__quick-add-toggle');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        // debounce: voorkom dubbele toggle binnen 350ms (touch-ghost-click safety)
        if (toggle.__vdLast && (Date.now() - toggle.__vdLast) < 350) return;
        toggle.__vdLast = Date.now();
        var card = toggle.closest('product-item, .product-item, [class*="product-item"], .grid__item, [data-product-id]');
        if (!card) {
          // Fallback — find sibling overlay
          card = toggle.parentElement;
        }
        var overlay = card.querySelector('.product-item__quick-select');
        if (!overlay) {
          // Try next sibling
          var sib = toggle.nextElementSibling;
          while (sib) {
            if (sib.classList && sib.classList.contains('product-item__quick-select')) { overlay = sib; break; }
            sib = sib.nextElementSibling;
          }
        }
        if (!overlay) return;
        document.querySelectorAll('.product-item__quick-select.is-open').forEach(function(el){
          if (el !== overlay) el.classList.remove('is-open');
        });
        document.querySelectorAll('.product-item__quick-add-toggle[aria-expanded="true"]').forEach(function(b){
          if (b !== toggle) b.setAttribute('aria-expanded','false');
        });
        var open = overlay.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (!e.target.closest('.product-item__quick-select')) {
        document.querySelectorAll('.product-item__quick-select.is-open').forEach(function(el){ el.classList.remove('is-open'); });
        document.querySelectorAll('.product-item__quick-add-toggle[aria-expanded="true"]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
      }
    }
    document.addEventListener('click', handleToggle, true);
    document.addEventListener('touchend', function(e){
      var t = e.target.closest('.product-item__quick-add-toggle');
      if (!t) return;
      if (e.cancelable) e.preventDefault(); // killt de aanhangende click + anchor-navigatie
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      handleToggle(e);
    }, { passive: false, capture: true });
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.product-item__quick-size');
      if (!btn) return;
      if (btn.classList.contains('is-unavailable') || btn.classList.contains('is-adding')) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.classList.add('is-adding');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: ['mini-cart','cart-drawer'],
          sections_url: window.location.pathname
        })
      })
      .then(function(r){
        if (!r.ok) throw new Error('add failed ' + r.status);
        return r.json();
      })
      .then(function(data){
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        // Get fresh cart for the refresh detail
        fetch('/cart.js').then(function(rr){ return rr.json(); }).then(function(cartContent){
          cartContent.sections = data.sections || {};
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart: cartContent, openMiniCart: true }
          }));
        });
        setTimeout(function(){ btn.classList.remove('is-added'); }, 1500);
      })
      .catch(function(err){
        console.error('[vd-quick-select] add failed', err);
        btn.classList.remove('is-adding');
      });
    }, true);
  })();
  